import { DatoComponentsWrapper } from "components/common/DatoComonentsWrappeer/DatoComponentsWrapper";
import { LocalizationContext } from "context/localization";
import { FC, useContext, useLayoutEffect, useState } from "react";

import { Faq } from "components/common/Faq/Faq";
import { getYotpoInstanceId } from "helpers/yotpo";
import { useRouter } from "next/router";
import { ProductBySlugQuery } from "services/datocms/generated";
import {
  ItemByGtinDocument,
  useItemByGtinQuery,
} from "services/graphql/generated";
import { ProductDetailsCylinder } from "./Cylinder/ProductDetailsCylinder";
import { ProductDetailsCylinderNew } from "./Cylinder/ProductDetailsCylinderNew";
import { ProductDetailsMachine } from "./Machine/ProductDetailsMachine";
import { ProductDetailsDefault } from "./ProductDetailsDefault";
import { ProductDetailsMachineV2 } from "./Machine/ProductDetailsMachineV2";

interface ProductDetailsProps {
  datoProduct: ProductBySlugQuery["product"] | null;
}

const ProductDetails: FC<ProductDetailsProps> = ({ datoProduct }) => {
  const [selectedImage, setSelectedImage] = useState<number>(0);
  const router = useRouter();

  const { formatPriceByLocale } = useContext(LocalizationContext);

  const { data: pepDirectProductData, loading } = useItemByGtinQuery({
    query: ItemByGtinDocument,
    variables: { gtin: datoProduct?.gtin || "" },
  });

  const pepDirectProduct = pepDirectProductData?.itemByGtin;
  const { gtin, imgUrl, price } = pepDirectProduct || {};

  // We are using useLayoutEffect because we strictly need to make sure that the DOM element is attached so that Yotpo script can successfully attach and render the widget. With useEffect, there is no guarantee of having the element in the DOM even if we have the React state setup
  useLayoutEffect(() => {
    if (pepDirectProduct?.gtin) {
      (window as any)?.yotpoWidgetsContainer?.initWidgets();
    }
  }, [pepDirectProduct?.gtin]);

  const renderBasedOnCategory = () => {
    if (datoProduct?.category)
      switch (datoProduct?.category?.style) {
        case "style3":
          if (router.query.exp === "v1") {
            return (
              <ProductDetailsCylinder
                datoProduct={datoProduct}
                pepDirectProduct={pepDirectProduct}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
              />
            );
          }
          return (
            <ProductDetailsCylinderNew
              datoProduct={datoProduct}
              pepDirectProduct={pepDirectProduct}
            />
          );
        case "style2":
          if (router?.query?.exp === "v1") {
            return (
              <ProductDetailsMachine
                datoProduct={datoProduct}
                pepDirectProduct={pepDirectProduct}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                loading={loading}
              />
            );
          } else {
            return (
              <ProductDetailsMachineV2
                datoProduct={datoProduct}
                pepDirectProduct={pepDirectProduct}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                loading={loading}
              />
            );
          }
        default:
          return (
            <ProductDetailsDefault
              datoProduct={datoProduct}
              selectedImage={selectedImage}
              setSelectedImage={setSelectedImage}
              pepDirectProduct={pepDirectProduct}
              loading={loading}
            />
          );
      }
  };

  const pageUrl = typeof window !== "undefined" ? window?.location?.href : "";

  return (
    <>
      {renderBasedOnCategory()}
      <DatoComponentsWrapper components={datoProduct?.components} />
      <div className="container py-8">
        {gtin && (
          <div
            className="yotpo-widget-instance"
            data-yotpo-image-url={imgUrl}
            data-yotpo-instance-id={getYotpoInstanceId("reviews")}
            data-yotpo-name={datoProduct?.title}
            data-yotpo-price={formatPriceByLocale(price, false)}
            data-yotpo-product-id={gtin}
            data-yotpo-url={pageUrl}
            data-yotpo-currency="PLN"
          />
        )}
      </div>
      {datoProduct?.faq && <Faq data={datoProduct?.faq} />}
    </>
  );
};

export default ProductDetails;
